<template>
  <content-with-sidebar class="blog-wrapper">

    <!-- blogs -->
    <b-row class="blog-list-wrapper">
      <b-col
        v-for="product in productList"
        :key="product.image"
        md="6"
      >
        <b-card
          tag="article"
          no-body
        >
          <b-link :to="{ name: 'pages-ideas-detail', params: product }">
            <b-img
              :src="product.image"
              :alt="product.image.slice(5)"
              class="card-img-top"
            />
          </b-link>
          <b-card-body>
            <b-card-title>
              <b-link
                :to="{ name: 'pages-ideas-detail', params: product }"
                class="blog-title-truncate text-body-heading"
              >
                {{ product.statement }}
              </b-link>
            </b-card-title>
            <b-media no-body>
              <b-media-body>
                <small class="mr-50">{{ product.name }}</small>
                <small class="text-muted mr-50">by</small>
                <small>
                  <b-link :to="{ name: 'apps-users-view', params: { id: product.username }}" class="text-body">{{ product.username }}</b-link>
                </small>
                <span class="text-muted ml-75 mr-50">|</span>
                <small class="text-muted">{{ product.date | dateFormat('MMMM DD, YYYY') }}</small>
              </b-media-body>
            </b-media>
            <div class="my-1 py-25">
              <b-badge class="mr-1" variant="primary" v-for="industry in product.industries"
                :key="industry">
                <span>{{ industry }}</span>
              </b-badge>
            </div>
            <!-- eslint-enable -->
            <hr class="my-2">
            <b-card-text class="blog-content-truncate">
              <div v-html="product.description"></div>
            </b-card-text>
            <hr>
            <div class="d-flex justify-content-between align-items-center">
              <b-link :to="{ path: `/pages/blog/${product.id}#blogComment`}">
                <div class="d-flex align-items-center text-body">
                  <feather-icon
                    icon="MessageSquareIcon"
                    class="mr-50"
                  />
                  <span class="font-weight-bold">{{ kFormatter(product.comments) }} Comments</span>
                </div>
              </b-link>
              <b-link
                :to="{ name: 'pages-ideas-detail', params: product }"
                class="font-weight-bold"
              >
                Read More
              </b-link>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12">
        <!-- pagination -->
        <div class="my-2">
          <b-pagination
            v-model="currentPage"
            align="center"
            :total-rows="rows"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-col>
    </b-row>

    <!--/ blogs -->

    <!-- sidebar -->
    <div
      slot="sidebar"
      class="blog-sidebar py-2 py-lg-0"
    >
      <!-- input search -->
      <b-form-group class="blog-search">
        <b-input-group class="input-group-merge">
          <b-form-input
            id="search-input"
            v-model="search_query"
            placeholder="Search Products or Ideas"
          />
          <b-input-group-append
            class="cursor-pointer"
            is-text
          >
            <feather-icon
              icon="SearchIcon"
            />
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <!--/ input search -->

      <!-- recent posts -->
      <div class="blog-recent-posts mt-3">
        <h6 class="section-label mb-75">
          Your Product or Ideas
        </h6>
        <b-media
          v-for="(yourProduct,index) in youProductList"
          :key="yourProduct.image"
          no-body
          :class="index? 'mt-2':''"
        >
          <b-media-aside class="mr-2">
            <b-link :to="{ name: 'pages-ideas-detail', params: yourProduct }">
              <b-img
                :src="yourProduct.image"
                :alt="yourProduct.image.slice(6)"
                width="100"
                rounded
                height="70"
              />
            </b-link>
          </b-media-aside>
          <b-media-body>
            <h6 class="blog-recent-post-title">
              <b-link
                :to="{ name: 'pages-ideas-detail', params: yourProduct }"
                class="text-body-heading"
              >
                {{ yourProduct.name }}
              </b-link>
            </h6>
            <span class="text-muted mb-0">
              {{ yourProduct.date | dateFormat('MMMM DD, YYYY') }}
            </span>
          </b-media-body>
        </b-media>
      </div>
      <!--/ recent posts -->
    </div>
    <!--/ sidebar -->
  </content-with-sidebar>
</template>

<script>
import {
  BRow, BCol, BCard, BFormInput, BCardText, BCardTitle, BMedia, BAvatar, BMediaAside, BMediaBody, BImg, BCardBody, BLink, BBadge, BFormGroup, BInputGroup, BInputGroupAppend, BPagination,
} from 'bootstrap-vue'
import { kFormatter } from '@core/utils/filter'
import ContentWithSidebar from '@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'
import { getFirestore, getDocs, query, orderBy, where, limit, collection} from 'firebase/firestore'
import { getAuth } from "firebase/auth"

const db = getFirestore()
const auth = getAuth()

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormInput,
    BCardText,
    BCardBody,
    BCardTitle,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BPagination,
    ContentWithSidebar,
  },
  watch: {
    search_query: {
      handler(val){
        console.log(val)
        const queryLowered = val.toLowerCase()
        // Filter products
        this.productList = this.unFilteredProducts.filter(product => (
          product.name.toLowerCase().includes(queryLowered) ||
          product.username.toLowerCase().includes(queryLowered) ||
          product.statement.toLowerCase().includes(queryLowered) ||
          product.description.toLowerCase().includes(queryLowered) ||
          ((product.industries)?product.industries.filter((a) => {  return a.toLowerCase().includes(queryLowered) }).length > 0:false) ||
          ((product.tags)?product.tags.filter((a) => {  return a.toLowerCase().includes(queryLowered) }).length > 0:false))
        )
      },
      deep: true
    }
  },
  data() {
    return {
      username: null,
      search_query: '',
      unFilteredProducts: [],
      productList: [],
      youProductList: [],
      blogSidebar: {},
      currentPage: 1,
      perPage: 1,
      rows: 140,
    }
  },
  created() {
    const uid =  (auth && auth.currentUser)?auth.currentUser.uid:null
    this.username = (auth && auth.currentUser)?auth.currentUser.displayName:null
    this.getProducts(uid)
  },
  methods:{
    kFormatter,
    tagsColor(tag) {
      if (tag === 'Quote') return 'light-info'
      if (tag === 'Gaming') return 'light-danger'
      if (tag === 'Fashion') return 'light-primary'
      if (tag === 'Video') return 'light-warning'
      if (tag === 'Food') return 'light-success'
      return 'light-primary'
    },
    async getProducts(uid) {
      const snapshot = await getDocs(query(collection(db, "products"), where("status",  "==", "Public"), orderBy("created_time", "desc"), limit(500)))
      snapshot.forEach(doc => {
        let product = doc.data()
        product.id = doc.id
        product.date = product.created_time.toDate()
        this.unFilteredProducts.push(product)
        this.productList.push(product)
      })

      const snapshot2 = await getDocs(query(collection(db, "products"), where("uid",  "==", uid), orderBy("created_time"), limit(20)))
      snapshot2.forEach(doc => {
        let product = doc.data()
        product.id = doc.id
        product.date = product.created_time.toDate()
        this.youProductList.push(product)
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';
</style>
